// LogoWithArrow.jsx
import React, { useRef, useEffect, useState } from "react";

const LogoWithArrow = ({
  text = "NammaEventz",
  fontSize = 40,
  color = "#FFFFFF",
  fontWeight = "700",
  letterSpacing = "normal",
  gradient = false,
}) => {
  const containerRef = useRef(null);
  const startRef = useRef(null);
  const endRef = useRef(null);
  const [coords, setCoords] = useState(null);

  const renderWrappedText = () => {
    const lower = text.toLowerCase();
    const firstAIndex = lower.indexOf("a");
    const lastZIndex = lower.lastIndexOf("z");

    return text.split("").map((ch, i) => {
      if (i === firstAIndex) {
        return (
          <span
            key={i}
            ref={startRef}
            style={{ display: "inline-block" }}
          >
            {ch}
          </span>
        );
      }
      if (i === lastZIndex) {
        return (
          <span
            key={i}
            ref={endRef}
            style={{ display: "inline-block" }}
          >
            {ch}
          </span>
        );
      }
      return (
        <span key={i} style={{ display: "inline-block" }}>
          {ch}
        </span>
      );
    });
  };

  useEffect(() => {
    const compute = () => {
      const c = containerRef.current;
      const s = startRef.current;
      const e = endRef.current;
      if (!c || !s || !e) return;

      const cR = c.getBoundingClientRect();
      const sR = s.getBoundingClientRect();
      const eR = e.getBoundingClientRect();

      const startX = sR.left - cR.left + sR.width / 2;
      const endX = eR.left - cR.left + eR.width / 2;

      // 🔥 Move arrow LOWER so it never overlaps
      const baselineY = (sR.bottom - cR.top) + 16;

      // Small smooth curve
      const curveHeight = 18;
      const controlX = (startX + endX) / 2;
      const controlY = baselineY + curveHeight;

      setCoords({
        startX,
        endX,
        baselineY,
        controlX,
        controlY,
        width: endX + 20,
        height: controlY + -0.60,
      });
    };

    compute();
    window.addEventListener("resize", compute);

    return () => window.removeEventListener("resize", compute);
  }, [text, fontSize]);

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        display: "inline-block",
        paddingBottom: "22px", // 🔥 extra bottom space to avoid overlap
      }}
    >
      <h2
        className={`font-ubuntu tracking-tight ${gradient ? 'bg-clip-text text-transparent bg-gradient-to-r from-[#A855F7] to-[#EC4899]' : ''}`}
        style={{
          color: gradient ? 'transparent' : color,
          fontSize,
          fontWeight,
          letterSpacing,
          margin: 0,
          lineHeight: 1,
        }}
      >
        {renderWrappedText()}
      </h2>

      {coords && (
        <svg
          width={coords.width}
          height={coords.height}
          style={{
            position: "absolute",
            left: 0,
            bottom: 0,
            pointerEvents: "none",
          }}
        >
          <path
            d={`M ${coords.startX} ${coords.baselineY}
               Q ${coords.controlX} ${coords.controlY}
               ${coords.endX} ${coords.baselineY}`}
            stroke={color}
            strokeWidth={3}
            fill="none"
            strokeLinecap="round"
          />

          {/* small arrow tip */}
          <path
            d={`
              M ${coords.endX - 6} ${coords.baselineY - 3}
              L ${coords.endX} ${coords.baselineY}
              L ${coords.endX - 6} ${coords.baselineY + 3}
            `}
            fill={color}
          />
        </svg>
      )}
    </div>
  );
};

export default LogoWithArrow;
